import * as React from 'react';

import { translate } from '~l10n/client';

import { PaywallScreens } from '~analytics/types';
import { UIButton } from '~shared/components/buttons';
import { DialogProps } from '~shared/components/Dialog';
import {
  PaywallDialog,
  PaywallUpgradeButton,
} from '~teacher/components/PaywallDialog';

export type Props = Pick<DialogProps, 'open' | 'onClose'>;

export function EmbedAudioVideoPaywall({ open, onClose, ...props }: Props) {
  return (
    <PaywallDialog.Short
      id="audio-video-embed-paywall"
      open={open}
      onClose={onClose}
      title={translate('Upgrade to Embed')}
      actions={[
        <UIButton key="cancel" onClick={onClose}>
          {translate('Cancel')}
        </UIButton>,
        <PaywallUpgradeButton
          key="upgrade"
          appearance="primary"
          paywallScreen={PaywallScreens.QuizEditEmbedAudioVideo}
        />,
      ]}
      closeLabel={translate('Close')}
      {...props}
      paywallTouch={[PaywallScreens.QuizEditEmbedAudioVideo]}
    >
      <p className="m-0 pb-4 text-blue-900">
        {translate('Embed from your favourite streaming platforms.')}
      </p>
    </PaywallDialog.Short>
  );
}
